import axios from "axios";

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL, // TODO: use env var based on environment
  withCredentials: true, // Always send cookies or credentials in requests
});

// Add a request interceptor to always use the latest token
axiosClient.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("accessTokenOq");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      delete config.headers.Authorization; // remove header if no token
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Add a response interceptor
axiosClient.interceptors.response.use(
  // Handle successful responses
  (response) => response,
  // Handle errors
  async (error) => {
    if (error.response?.status === 401) {
      // Avoid redirect loop if already on login page
      const loginUrl = `${process.env.REACT_APP_SITE_URL}/login`;
      if (window.location.href !== loginUrl) {
        alert("Your session has expired. Please login again.");
        window.location.href = loginUrl;
      }
    }
    return Promise.reject(error);
  },
);

export default axiosClient;
